import { render, staticRenderFns } from "./group.vue?vue&type=template&id=44a79fb6&scoped=true&"
import script from "./group.js?vue&type=script&lang=js&"
export * from "./group.js?vue&type=script&lang=js&"
import style0 from "./group.vue?vue&type=style&index=0&id=44a79fb6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44a79fb6",
  null
  
)

export default component.exports